import { Flex, Tag } from 'antd';
import type { SiteOperationsMapSummary } from '~/app/services/site/site.service';

type SupervisorOperationsMapSummaryTagsProps = {
  summary: SiteOperationsMapSummary;
  missingCoordinatesCount: number;
};

export function SupervisorOperationsMapSummaryTags({
  summary,
  missingCoordinatesCount,
}: SupervisorOperationsMapSummaryTagsProps) {
  return (
    <Flex gap={12} wrap="wrap">
      <Tag color="blue" style={{ marginInlineEnd: 0, borderRadius: 999 }}>
        {summary.siteCount} sites
      </Tag>
      <Tag color="geekblue" style={{ marginInlineEnd: 0, borderRadius: 999 }}>
        {summary.zoneCount} zones
      </Tag>
      <Tag color="red" style={{ marginInlineEnd: 0, borderRadius: 999 }}>
        {summary.totalOpenIncidents} open incidents
      </Tag>
      <Tag color="gold" style={{ marginInlineEnd: 0, borderRadius: 999 }}>
        {summary.warningAssets + summary.criticalAssets} affected assets
      </Tag>
      {missingCoordinatesCount > 0 ? (
        <Tag color="default" style={{ marginInlineEnd: 0, borderRadius: 999 }}>
          {missingCoordinatesCount} hidden without coordinates
        </Tag>
      ) : null}
    </Flex>
  );
}
